import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { isValidBusiness } from '../../entities/Business';
import { BaseClient } from '../BaseClient';
export class BusinessClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "createBusinessesImpl", void 0);
    _defineProperty(this, "getBusinessImpl", void 0);
    _defineProperty(this, "listBusinessesImpl", void 0);
    _defineProperty(this, "listIndividualBusinessesImpl", void 0);
    _defineProperty(this, "queryBusinessesImpl", void 0);
  }
  async createBusiness(business) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      const {
        business: createdBusiness
      } = await this.request(this.createBusinessesImpl({
        business: {
          displayName: business.displayName
        }
      }), ...args);
      if (!business) {
        throw new Error("Can't create business");
      }
      return this.convertToEntity(createdBusiness);
    } catch (error) {
      this.logError('createBusiness', 'Failed to create business', {
        business
      }, error);
      throw error;
    }
  }
  async getBusiness(businessId) {
    try {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      const {
        business
      } = await this.request(this.getBusinessImpl({
        businessId
      }), ...args);
      if (!business) {
        throw new Error("Can't find business");
      }
      return this.convertToEntity(business);
    } catch (error) {
      this.logError('getBusiness', 'Failed to get business', {
        businessId
      }, error);
      throw error;
    }
  }
  async listBusinesses() {
    try {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      const {
        businesses
      } = await this.request(this.listBusinessesImpl({}), ...args);
      return (businesses == null ? void 0 : businesses.map(this.convertToEntity)) || [];
    } catch (error) {
      this.logError('listBusinesses', 'Failed to list businesses', {}, error);
      throw error;
    }
  }
  async queryBusinesses(query) {
    try {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      const {
        items,
        cursor,
        count,
        hasNext
      } = await this.request(this.queryBusinessesImpl({
        query
      }), ...args);
      return {
        items: (items == null ? void 0 : items.map(this.convertToEntity)) || [],
        cursor,
        hasNext: hasNext ?? undefined,
        count
      };
    } catch (error) {
      this.logError('queryBusinesses', 'Failed to query businesses', {
        query
      }, error);
      throw error;
    }
  }
  async listIndividualBusinesses() {
    try {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      const {
        businesses
      } = await this.request(this.listIndividualBusinessesImpl({}), ...args);
      return (businesses == null ? void 0 : businesses.map(this.convertToEntity)) || [];
    } catch (error) {
      this.logError('listIndividualBusinesses', 'Failed to list individual businesses', {}, error);
      throw error;
    }
  }
  convertToEntity(business) {
    try {
      if (!business) {
        throw new Error('Invalid business', {
          cause: {
            business
          }
        });
      }
      if (isValidBusiness(business)) {
        return business;
      }
      throw new Error('Invalid business data', {
        cause: {
          business
        }
      });
    } catch (error) {
      this.logError('convertToEntity', 'Failed to convert business', {
        business
      }, error);
      throw error;
    }
  }
  getServiceNameForLogs() {
    return 'BusinessClient';
  }
}
//# sourceMappingURL=BusinessClientBase.js.map